import React, { useState } from "react";
import { useQuery } from "react-query";
import UserService from "../../services/userService";
import { UserResponse } from "../../types/user";
import ChangePassword from "./ChangePassword";
import BillingAddress from "./components/BillingAddress";
import Myinfo from "./components/MyInfo";

const MyProfile: React.FC = () => {
  const [showChangePassword, setShowChangePassword] = useState(false);
  const { data: userData, isLoading } = useQuery<UserResponse>(
    ["profile"],
    async () => UserService.getProfile(),
  );
  if (isLoading) return null;

  return (
    <div>
      {showChangePassword ? (
        <ChangePassword />
      ) : (
        <div className="flex w-[calc(100vw_-_3rem)] flex-col gap-[1.875rem] rounded-[1.25rem] sm:w-[46.25rem]">
          <Myinfo
            userInfo={userData?.userInfo}
            onChangePassword={() => {
              setShowChangePassword(true);
            }}
          />

          {/* block2 */}
          <BillingAddress billingAdress={userData?.billingAddress} />
        </div>
      )}
    </div>
  );
};

export default MyProfile;
